var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1527",
    "data-name": "Group 1527",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.831,
    height: 15.35,
    viewBox: "0 0 21.831 15.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email_3_",
    "data-name": "email (3)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3031",
    "data-name": "Group 3031",
    transform: "translate(1.118 8.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3030",
    "data-name": "Group 3030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39317",
    "data-name": "Path 39317",
    d: "M39.254,277.251l-1.828,1.835a2.024,2.024,0,0,1-2.8,0l-1.828-1.835-6.567,6.588a1.9,1.9,0,0,0,.8.181H45.02a1.9,1.9,0,0,0,.8-.18Z",
    transform: "translate(-26.226 -277.251)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3033",
    "data-name": "Group 3033",
    transform: "translate(1.118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3032",
    "data-name": "Group 3032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39318",
    "data-name": "Path 39318",
    d: "M45.022,76H27.028a1.9,1.9,0,0,0-.8.18l7.017,7.041h0l2.282,2.289a.768.768,0,0,0,.992,0L38.8,83.224h0l7.017-7.041A1.9,1.9,0,0,0,45.022,76Z",
    transform: "translate(-26.228 -76)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3035",
    "data-name": "Group 3035",
    transform: "translate(0 1.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3034",
    "data-name": "Group 3034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39319",
    "data-name": "Path 39319",
    d: "M.2,101.212a1.9,1.9,0,0,0-.2.844v11.513a1.9,1.9,0,0,0,.2.844l6.578-6.6Z",
    transform: "translate(0 -101.212)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3037",
    "data-name": "Group 3037",
    transform: "translate(15.049 1.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3036",
    "data-name": "Group 3036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39320",
    "data-name": "Path 39320",
    d: "M359.511,101.21l-6.578,6.6,6.578,6.6a1.9,1.9,0,0,0,.2-.844V102.054A1.9,1.9,0,0,0,359.511,101.21Z",
    transform: "translate(-352.933 -101.21)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f2353aed5562142fae62f9593457b9a8.svg";
export { ForwardRef as ReactComponent };